import hvcb from "../../../../assets/images/productos/hvcb/HVCB.png";
import qr from "../../../../assets/images/QR Fabian Llamazares.svg";
import Producto from "../../../../components/producto";
import pic1 from "../../../../assets/images/productos/hvcb/Mosaico - HV1.png";
import pic2 from "../../../../assets/images/productos/hvcb/Mosaico - HV2.png";
import pic3 from "../../../../assets/images/productos/hvcb/Mosaico - HV3.png";
import pic4 from "../../../../assets/images/productos/hvcb/Mosaico - HV4.png";

import { useTranslation } from "react-i18next";

function HVCB() {

  const { t } = useTranslation();

  return (
    <Producto
      fotos={[pic1, pic2, pic3, pic4]}
      datosTabla1={[
        [t("tensionMaximaDeServicio"), "kV", "145"],
        [t("corrienteNominal"), "A", "3.150"],
        [t("corrienteBreveDuracion"), "kA (4sec)", "40"],
        [t("corrienteDePicoSoportada"), "kA", "100"],
        [t("tensionSoportadaFrecuenciaIndustrial"), "kV", "315 / 1 min"],
        [t("tensionSoportadaImpulsoIndustrial"), "kV", "650 / 750"],
        [t("frecuenciaNominal"), "Hz", "50/60"],
        [t("presionNominal"), "kg/cm2", "7"]
      ]}
      datosTabla2={[
        [t("ancho"), "mm", "3.985"],
        [t("alto"), "mm", "5.540"],
        [t("profundidad"), "mm", "625"],
      ]}
      nombreProducto={"HVCB"}
      fotoProducto={hvcb}
      descripcionProducto={
        t("hvcb.titulo_descripcion")
      }
      caracteristicas={[
      ]}
      vendedor={{
        nombre: "Fabian Llamazares",
        telefono: "+54 9 11 5096-3680",
        mail: "fllamazares@ema.com.ar",
        qr: qr,
      }}
      pathPdf={'/assets/docs/2025%20-%20HVCB.pdf'}
    />
  );
}

export default HVCB;